var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isAdmin)?_c('div',{staticClass:"chui-gaki"},[_vm._v("プロキュアメントチーム以外の登録・変更厳禁（同時作業は一人まで）")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }